import { Component, OnInit, Input, HostBinding, AfterViewInit, ChangeDetectorRef, OnChanges, SimpleChange } from '@angular/core';
import { Subscription } from 'rxjs';
import { FollowService } from 'src/app/shared/services/follow.service';

@Component({
  selector: 'complement-follow',
  template: `<div class="spinner-border" *ngIf="loading"><span class="sr-only">Loading...</span></div><icons icon="heart" [type]="iconType" [class]="classIcon" [ngClass]="[text? 'mr-1' : '']"></icons>{{text}}`,
  styleUrls: ['./follow.component.scss'],
  host:{"(click)": "follow($event)"}
})
export class ComplementFollowComponent implements OnInit, OnChanges, AfterViewInit {

  @HostBinding('className') className = '';
  @HostBinding('attr.data-placement') dataPlacement = 'top';
  @HostBinding('attr.data-toggle') dataToggle = 'tooltip';
  @HostBinding('attr.data-original-title') tooltip = '';
  
  constructor(
    private fs : FollowService,
    private cd: ChangeDetectorRef
  ) { }

  
  @Input() loading : boolean = false;
  @Input() type : any;
  @Input() template : any = 'default';
  @Input() data : any;
  @Input() classTag : any = '';
  @Input() classIcon : any = ' md m-1';

  text = '';
  iconType = 'light';

  private subscribe:Subscription;
  private subscribeAction:Subscription;


  following = false;

  ngOnInit() {
    this.subscribe = this.fs.following$.subscribe(result => {
      this.updateHostData();
    });
    
    this.subscribeAction = this.fs.followingAction$.subscribe(result => {
      if(this.data.id == result?.id)
        this.updateAction(result);
    });

    this.updateHostData();
  }
  ngOnDestroy(){
    if(this.subscribe)
      this.subscribe.unsubscribe();

    if(this.subscribeAction)
      this.subscribeAction.unsubscribe();
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    
    if(changes?.data){
      this.updateHostData();
    }
  }

  ngAfterViewInit(){
    
  }
  
  updateHostData(){

    this.following = this.fs.isFollow(this.type,this.data.id);
    //console.log(this.data.id, this.following);

    let cls = 'fav follow-' + this.template + ' ';
    
    if(this.template=='person-advertise'){
      cls+='btn btn-sm pl-1 d-flex justify-content-center';
      cls+= this.following? ' following btn-secondary' : ' btn-light text-primary';
      this.classIcon = this.following? 'white md m-1' : 'black md m-1';      
      this.text = this.following? 'Favorito' : '';
      this.iconType = this.following? 'solid' : 'light';
    } else if(this.template=='person-ad'){
      cls+='btn btn-sm pl-1 d-flex justify-content-center';
      cls+= this.following? ' following btn-secondary' : ' btn-light text-primary';
      this.classIcon = this.following? 'white md m-1' : 'black md m-1';      
      this.text = this.following? 'Favorito' : '';
    } else {
      this.tooltip = this.following? 'Favorito' : '';
      cls+= this.following? ' following' : '';
      this.iconType = this.following? 'solid' : 'light';
    }
    
    this.className = cls+' '+this.classTag;
    this.cd.detectChanges();
  }

  follow(event){
    event.stopPropagation();
    this.fs.follow(this.type, this.data);
  }

  updateAction(data){
    switch(data.action){
      case 'loading':
        this.loading=true;
      break;
      default:
        this.loading=false;
      break;
    }
  }

}